// extracted by mini-css-extract-plugin
module.exports = {"table":"MultipleResultsTable_table__uERRn"};